<div class="educations-list">
  <!-- Hero with search -->
  <div class="educations-list__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'educations.list.hero_title' | translate }}</h1>

      <div class="educations-list__search">
        <div class="educations-list__search-fields">
          <div class="educations-list__search-field">
            <div class="educations-list__search-label">{{ 'shared.what' | translate }}</div>
            <div class="educations-list__search-input-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
              </svg>
              <input
                type="text"
                [(ngModel)]="searchWat"
                (keydown.enter)="handleSearch()"
                [placeholder]="'educations.list.search_placeholder_what' | translate"
              />
            </div>
          </div>

          <div class="educations-list__search-divider"></div>

          <div class="educations-list__search-field">
            <div class="educations-list__search-label">{{ 'shared.where' | translate }}</div>
            <div class="educations-list__search-input-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
              </svg>
              <input
                type="text"
                [(ngModel)]="searchWaar"
                (keydown.enter)="handleSearch()"
                [placeholder]="'educations.list.search_placeholder_where' | translate"
              />
            </div>
          </div>
        </div>

        <button class="educations-list__search-btn" (click)="handleSearch()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Skill shortcuts -->
  <div class="vacancy-container educations-list__content">
    <div class="educations-list__skills-section">
      <h2 class="educations-list__section-title">{{ 'educations.list.skills_title' | translate }}</h2>
      <p class="educations-list__section-subtitle">{{ 'educations.list.skills_subtitle' | translate }}</p>
      <div class="educations-list__skill-pills">
        <button
          *ngFor="let skill of skillLabels"
          class="educations-list__skill-pill"
          (click)="navigateToSkill(skill)"
        >
          {{ skill }}
        </button>
      </div>
    </div>

    <!-- Education cards -->
    <div class="educations-list__cards-section">
      <h2 class="educations-list__section-title">{{ 'educations.list.courses_title' | translate }}</h2>

      <div class="vacancy-grid">
        <bwc-education-card
          *ngFor="let education of visibleEducations"
          [education]="education"
          [isLiked]="isLiked(education.id)"
          (liked)="toggleLike($event)"
        ></bwc-education-card>
      </div>

      <div class="vacancy-load-more" *ngIf="hasMore">
        <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
      </div>
    </div>
  </div>
</div>
